{
  "title": "Nathair's Mischief",
  "source": "Fizban's Treasury of Dragons",
  "levelAndSchool": "2nd-level Illusion",
  "level": 2,
  "castingTime": "1 Action",
  "range": "60ft",
  "components": "S, M (a piece of crust from an apple pie)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You fill a 20-foot cube you can see within range with fey and draconic magic. Roll on the Mischievous Surge table to determine the magical effect produced, and roll again at the start of each of your turns until the spell ends. You can move the cube up to 10 feet before you roll.",
    "Mischievous Surge",
    "d4",
    "Effect",
    "1",
    "The smell of apple pie fills the air, and each creature in the cube must succeed on a Wisdom saving throw or become charmed by you until the start of your next turn.",
    "2",
    "Bouquets of flowers appear all around, and each creature in the cube must succeed on a Dexterity saving throw or be blinded until the start of your next turn as the flowers spray water in their faces.",
    "3",
    "Each creature in the cube must succeed on a Wisdom saving throw or begin giggling until the start of your next turn. A giggling creature is incapacitated and uses all its movement to move in a random direction.",
    "4",
    "Drops of molasses appear and hover in the cube, turning it into difficult terrain until the start of your next turn."
  ],
  "spellLists": ["bard", "arcane-trickster", "sorcerer", "wizard"]
}
